/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Хелпер для установки кук
   */
  app.helpers.CookieHelper = {

    /**
     * Получение куки
     * @param name Название куки
     * @returns {*}
     */
    getCookie: function (name) {
      var matches = document.cookie.match(new RegExp(
          '(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'
        )),
        value;
      if (matches) {
        value = decodeURIComponent(matches[1]);
        try {
          value = JSON.parse(value);
        } catch (e) {
        }
      }
      return value;
    },

    /**
     * Установка куки
     * @param name Название куки
     * @param value Значение
     * @param options Опции
     */
    setCookie: function (name, value, options) {
      options = options || {};

      var expires = options.expires;

      if (typeof expires === 'number' && expires) {
        var d = new Date();
        d.setTime(d.getTime() + expires * 1000);
        expires = options.expires = d;
      }
      if (expires && expires.toUTCString) {
        options.expires = expires.toUTCString();
      }
      if (_.isArray(value)) {
        value = JSON.stringify(value);
      }

      value = encodeURIComponent(value);

      var updatedCookie = name + '=' + value;

      for (var propName in options) {
        if (options.hasOwnProperty(propName)) {
          updatedCookie += '; ' + propName;
          var propValue = options[propName];
          if (propValue !== true) {
            updatedCookie += '=' + propValue;
          }
        }
      }

      document.cookie = updatedCookie;
    },
    /**
    * Удаление куки
    * @param {String} name       Название куки
    * @param {*} [options]         Опции
    */
    removeCookie: function (name, options) {
        options = options || {};
        options.expires = -1;
        this.setCookie(name, '', options);
    }
  };
})();

}.call(window));